"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowCapabilitiesToJSON = exports.WorkflowCapabilitiesFromJSONTyped = exports.WorkflowCapabilitiesFromJSON = exports.instanceOfWorkflowCapabilities = exports.WorkflowCapabilitiesProjectTypesEnum = exports.WorkflowCapabilitiesEditorScopeEnum = void 0;
const AvailableWorkflowConnectRule_1 = require("./AvailableWorkflowConnectRule");
const AvailableWorkflowForgeRule_1 = require("./AvailableWorkflowForgeRule");
const AvailableWorkflowSystemRule_1 = require("./AvailableWorkflowSystemRule");
const AvailableWorkflowTriggers_1 = require("./AvailableWorkflowTriggers");
/**
 * @export
 */
exports.WorkflowCapabilitiesEditorScopeEnum = {
    Project: 'PROJECT',
    Global: 'GLOBAL'
};
/**
 * @export
 */
exports.WorkflowCapabilitiesProjectTypesEnum = {
    Software: 'software',
    ServiceDesk: 'service_desk',
    ProductDiscovery: 'product_discovery',
    Business: 'business',
    Unknown: 'unknown'
};
/**
 * Check if a given object implements the WorkflowCapabilities interface.
 */
function instanceOfWorkflowCapabilities(value) {
    return true;
}
exports.instanceOfWorkflowCapabilities = instanceOfWorkflowCapabilities;
function WorkflowCapabilitiesFromJSON(json) {
    return WorkflowCapabilitiesFromJSONTyped(json, false);
}
exports.WorkflowCapabilitiesFromJSON = WorkflowCapabilitiesFromJSON;
function WorkflowCapabilitiesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'connectRules': json['connectRules'] == null ? undefined : (json['connectRules'].map(AvailableWorkflowConnectRule_1.AvailableWorkflowConnectRuleFromJSON)),
        'editorScope': json['editorScope'] == null ? undefined : json['editorScope'],
        'forgeRules': json['forgeRules'] == null ? undefined : (json['forgeRules'].map(AvailableWorkflowForgeRule_1.AvailableWorkflowForgeRuleFromJSON)),
        'projectTypes': json['projectTypes'] == null ? undefined : json['projectTypes'],
        'systemRules': json['systemRules'] == null ? undefined : (json['systemRules'].map(AvailableWorkflowSystemRule_1.AvailableWorkflowSystemRuleFromJSON)),
        'triggerRules': json['triggerRules'] == null ? undefined : (json['triggerRules'].map(AvailableWorkflowTriggers_1.AvailableWorkflowTriggersFromJSON)),
    };
}
exports.WorkflowCapabilitiesFromJSONTyped = WorkflowCapabilitiesFromJSONTyped;
function WorkflowCapabilitiesToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'connectRules': value['connectRules'] == null ? undefined : (value['connectRules'].map(AvailableWorkflowConnectRule_1.AvailableWorkflowConnectRuleToJSON)),
        'editorScope': value['editorScope'],
        'forgeRules': value['forgeRules'] == null ? undefined : (value['forgeRules'].map(AvailableWorkflowForgeRule_1.AvailableWorkflowForgeRuleToJSON)),
        'projectTypes': value['projectTypes'],
        'systemRules': value['systemRules'] == null ? undefined : (value['systemRules'].map(AvailableWorkflowSystemRule_1.AvailableWorkflowSystemRuleToJSON)),
        'triggerRules': value['triggerRules'] == null ? undefined : (value['triggerRules'].map(AvailableWorkflowTriggers_1.AvailableWorkflowTriggersToJSON)),
    };
}
exports.WorkflowCapabilitiesToJSON = WorkflowCapabilitiesToJSON;
//# sourceMappingURL=WorkflowCapabilities.js.map